<!-- @format -->

<div class="row">
  <div class="col-md-12">
    <label *ngIf="label">{{ label }}</label>
    <ng-content></ng-content>
    <!-- eslint-disable-next-line custom-rules/no-inner-html-property-binding -->
    <div class="form-control-static" [innerHtml]="value | markupString"></div>
  </div>
</div>
